// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LWXB","comment":"styles_comment__2NHDW"};